import request from '@/utils/request'

export function getList(data) {
  return request({
    url: '/user/user/user/album/list',
    method: 'post',
    data
  })
}
export function show(params) {
  return request({
    url: '/user/user/user/album/show',
    method: 'get',
    params
  })
}

export function hasExpMenu() {
  return request({
    url: '/user/user/user/album/getUploadAuth',
    method: 'post'
  })
}
export function uploadYun(data) {
  return request({
    url: '/user/user/user/album/uploadImagesToYun',
    method: 'post',
    data
  })
}
// 中朱
export function add(data) {
  return request({
    url: '/user/user/user/album/add',
    method: 'post',
    data
  })
}

export function remove(data) {
  return request({
    url: '/user/user/user/album/delete',
    method: 'post',
    data,
    transformRequest: data => {
      let index = 0
      let ret = ''

      for (const it in data) {
        if (data[it] !== undefined) {
          if (index > 0) {
            ret += '&'
          }
          if (data[it] !== null && data[it] !== undefined) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it])
            index++
          }
        }
      }
      return ret
    },

    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export function update(data) {
  return request({
    url: '/user/user/user/album/update',
    method: 'post',
    data
  })
}

export function getAlbumImageList(data) {
  return request({
    url: '/user/user/user/album/getAlbumImageList',
    method: 'post',
    data
  })
}

export function getAllAlbumList(data) {
  return request({
    url: '/user/user/user/album/getAllAlbumList',
    method: 'post',
    data
  })
}

export function getStatisticsInfo(data) {
  return request({
    url: '/user/user/personStatistics/getStatisticsInfo',
    method: 'post',
    data
  })
}
export function getOtherInfo(data) {
  return request({
    url: '/user/user/personStatistics/getOtherInfo',
    method: 'post',
    data
  })
}

export function getUserInfo(data) {
  return request({
    url: '/user/user/personStatistics/getUserInfo',
    method: 'post',
    data
  })
}
export function getRankInfo(data) {
  return request({
    url: '/user/user/personStatistics/getRankInfo',
    method: 'post',
    data
  })
}

export function delImage(data) {
  return request({
    url: 'user/user/user/album/delImage',
    method: 'post',
    data,
    transformRequest: data => {
      let index = 0
      let ret = ''

      for (const it in data) {
        if (data[it] !== undefined) {
          if (index > 0) {
            ret += '&'
          }
          if (data[it] !== null && data[it] !== undefined) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it])
            index++
          }
        }
      }
      return ret
    },

    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export function copyImage(data) {
  return request({
    url: 'user/user/user/album/copyImage',
    method: 'post',
    data
  })
}

export function moveImage(data) {
  return request({
    url: 'user/user/user/album/moveImage',
    method: 'post',
    data
  })
}
export function addCollect(data) {
  return request({
    url: 'user/user/user/userChatContent/addCollect',
    method: 'post',
    data
  })
}

export function getAlbumListById(data) {
  return request({
    url: 'user/user/user/album/getAlbumListById',
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/works/photos.js